import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "store/store.interface";
import { Box, Button, Card, Snackbar, Text, Dialog } from "common";
import { Add } from "@material-ui/icons";
import { useStyles } from "./CartBundleDashboard.style";
import { clearCreationBundleForm } from "store/actions/bundlePromotion.actions";
import { IconButton, useMediaQuery, useTheme } from "@material-ui/core";
import {
  BUNDLE_PROMOTION_FETCH_CAMPAIGNS,
  BUNDLE_PROMOTION_UPDATE_STATUS,
} from "store/store.types";
import { useApiInfo } from "hooks";
import { clearApi } from "store/actions/api.actions";
import ListIcon from "@material-ui/icons/Reorder";
import GridIcon from "@material-ui/icons/Apps";
import BundlePromotionListing from "components/BundlePromotion/CartBundleDashboard/BundlePromotionListing";
import LoadMoreBundleCampaign from "./LoadMoreBundleCampaign";
import SelectBundleOptions from "./BundleModal";
import BundleFilters from "./BundleFilters";

const CartBundleDashboard: React.FC = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { buttonWrapper } = useStyles({});

  const dispatch = useDispatch();

  const [listing, setListing] = useState<any>("list");

  const {
    canCreateCampaigns = [],
    roles = [],
    bundleDashboard,
  } = useSelector((state: IState) => ({
    ...state.bundlePromotion,
    ...state.auth,
    ...state.config,
  }));

  const canCreateCampaign = useMemo(() => {
    const role = roles[0];
    return canCreateCampaigns && canCreateCampaigns.indexOf(role) > -1;
  }, [roles, canCreateCampaigns]);

  const [isSelectedBundleOpen, setIsSelectedBundleOpen] = useState(false);

  const onClickHandler = () => {
    setIsSelectedBundleOpen((old) => !old);
  };

  useEffect(() => {
    dispatch(clearCreationBundleForm());
  }, [dispatch]);

  const { error } = useApiInfo(BUNDLE_PROMOTION_FETCH_CAMPAIGNS);
  const { error: updateStatusError } = useApiInfo(
    BUNDLE_PROMOTION_UPDATE_STATUS
  );

  const onCloseError = () => {
    dispatch(clearApi(BUNDLE_PROMOTION_FETCH_CAMPAIGNS));
    dispatch(clearApi(BUNDLE_PROMOTION_UPDATE_STATUS));
  };

  const onClickList = () => {
    setListing("list");
  };

  const onClickGrid = () => {
    setListing("grid");
  };

  return (
    <>
      {(error || updateStatusError) && (
        <Snackbar
          horizontal="center"
          vertical="top"
          variant="filled"
          severity="error"
          handleClose={onCloseError}
          open={!!error || !!updateStatusError}
        >
          {error ?? updateStatusError}
        </Snackbar>
      )}
      {isSelectedBundleOpen && (
        <Dialog
          open={isSelectedBundleOpen}
          onBackdropClick={onClickHandler}
          onClose={onClickHandler}
          dialogTitle={
            <Text
              fontSize="14px"
              fontWeight={500}
              textAlign="center"
              minWidth={["100%", "450px", "450px", "450px"]}
            >
              SELECT BUNDLE CAMPAIGN TYPE
            </Text>
          }
        >
          <SelectBundleOptions onFinish={onClickHandler} />
        </Dialog>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={["column-reverse", "row", "row", "row"]}
        my={["0px", "15px", "15px", "15px"]}
      >
        <Text
          fontSize="22px"
          fontWeight={600}
          mt={["10px", "0px", "0px", "0px"]}
        >
          Bundle Promotions
        </Text>
        {canCreateCampaign && (
          <Button
            fontSize="14px"
            fontWeight={600}
            minWidth="220px"
            padding="10px"
            round
            color="secondary"
            onClick={onClickHandler}
            variant="contained"
          >
            <Box className={buttonWrapper} display="flex" alignItems="center">
              <Add color="inherit" /> <span>Create Bundle</span>
            </Box>
          </Button>
        )}
      </Box>
      <Box>
        <Card
          padding={["30px 15px", "30px"]}
          borderRadius="5px"
          boxShadow="0px 0px 16px 0px rgb(0 0 0 / 9%)"
          marginTop="15px"
        >
          <Box
            display="flex"
            padding="0 0 25px 0"
            borderBottom={`1px solid ${theme.palette.background.default}`}
            justifyContent="space-between"
            alignItems="center"
          >
            <BundleFilters />
            {!isTablet && (
              <Box
                gridTemplateColumns="1fr 1fr"
                gridGap="10px"
                height="fit-content"
                margin="20px 0px 0px"
              >
                <IconButton onClick={onClickList}>
                  <ListIcon color="primary" />
                </IconButton>
                <IconButton onClick={onClickGrid}>
                  <GridIcon color="primary" />
                </IconButton>
              </Box>
            )}
          </Box>
          <BundlePromotionListing listing={listing} />
          {bundleDashboard && bundleDashboard.length > 0 && (
            <LoadMoreBundleCampaign />
          )}
        </Card>
      </Box>
    </>
  );
};

export default CartBundleDashboard;
